import { useEffect } from 'react';

import { useI18nInstance } from './useI18nInstance';

/**
 * Shows the pages under this component in `language` and gives the user's language back when
 * they close. Nothing is stored: the user's own pick stays in place for the other pages and the
 * next visit.
 */
export function useScopedLanguage(language: string): void {
    const instance = useI18nInstance();

    useEffect(() => {
        const usersLanguage = instance.language;
        if (usersLanguage === language) return;
        void instance.changeLanguage(language);
        return () => {
            void instance.changeLanguage(usersLanguage);
        };
    }, [instance, language]);
}
